export const ANDROID_APP_DETAILS_REQUEST = 'ANDROID_APP_DETAILS_REQUEST';
export const ANDROID_APP_DETAILS_SUCCESS = 'ANDROID_APP_DETAILS_SUCCESS';
export const ANDROID_APP_DETAILS_FAILURE = 'ANDROID_APP_DETAILS_FAILURE';

export const ANDROID_APP_BATCH_DETAILS_REQUEST = 'ANDROID_APP_BATCH_DETAILS_REQUEST';
export const ANDROID_APP_BATCH_DETAILS_SUCCESS = 'ANDROID_APP_BATCH_DETAILS_SUCCESS';
export const ANDROID_APP_BATCH_DETAILS_FAILURE = 'ANDROID_APP_BATCH_DETAILS_FAILURE';

export const ANDROID_APP_RECOMMEND_REQUEST = 'ANDROID_APP_RECOMMEND_REQUEST';
export const ANDROID_APP_RECOMMEND_SUCCESS = 'ANDROID_APP_RECOMMEND_SUCCESS';
export const ANDROID_APP_RECOMMEND_FAILURE = 'ANDROID_APP_RECOMMEND_FAILURE';

export const ANDROID_APP_STE_SHOW_QRCODE = 'ANDROID_APP_STE_SHOW_QRCODE';

export const ANDROID_APP_GROUP_SUCCESS = 'ANDROID_APP_GROUP_SUCCESS';
export const ANDROID_APP_GROUP_REQUEST = 'ANDROID_APP_GROUP_REQUEST';

export const ANDROID_APP_GIFT_REQUEST = 'ANDROID_APP_GIFT_REQUEST';
export const ANDROID_APP_GIFT_SUCCESS = 'ANDROID_APP_GIFT_SUCCESS';

export const ANDROID_APP_GIFT_RECEIVE_REQUEST = 'ANDROID_APP_GIFT_RECEIVE_REQUEST';
export const ANDROID_APP_GIFT_RECEIVE_SUCCESS = 'ANDROID_APP_GIFT_RECEIVE_SUCCESS';
